import { Link } from "react-router-dom";
import { useHref, useT } from "@/i18n";

export const Footer = () => {
  const href = useHref();
  const t = useT();

  const nav = [
    { to: "/directory", label: t("nav.directory"), testId: "footer-directory-link" },
    { to: "/harga", label: t("nav.pricing"), testId: "footer-pricing-link" },
    { to: "/submit", label: t("nav.submit"), testId: "footer-submit-link" },
    { to: "/claim", label: t("footer.claim"), testId: "footer-claim-link" },
  ];
  const legal = [
    { to: "/terma", label: t("footer.terms"), testId: "footer-terms-link" },
    { to: "/privasi", label: t("footer.privacy"), testId: "footer-privacy-link" },
    { to: "/pemulangan", label: t("footer.refund"), testId: "footer-refund-link" },
    { to: "/hubungi", label: t("footer.contact"), testId: "footer-contact-link" },
  ];

  return (
    <footer className="mt-12 border-t border-border bg-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <p className="font-display text-base font-bold tracking-tight">
            Direktori<span className="text-primary">Biz</span>.my
          </p>
          <p className="mt-1 max-w-sm text-sm text-slate-500">{t("footer.tagline")}</p>
          <div className="mt-5 text-sm text-slate-600">
            <p className="font-semibold text-slate-900">YBD INFINITY GLOBAL</p>
            <p className="mt-0.5">{t("footer.regno")}: 202603212324 (JM1048394-W)</p>
            <a href="mailto:info@direktoribiz.my" className="mt-0.5 inline-block transition-colors duration-200 hover:text-primary">
              info@direktoribiz.my
            </a>
          </div>
        </div>

        {[
          { title: t("footer.col.directory"), items: nav },
          { title: t("footer.col.legal"), items: legal },
        ].map((col) => (
          <div key={col.title}>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">{col.title}</p>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
              {col.items.map((l) => (
                <li key={l.to}>
                  <Link to={href(l.to)} data-testid={l.testId} className="transition-colors duration-200 hover:text-primary">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-border">
        <div className="mx-auto max-w-7xl px-4 py-5 text-xs text-slate-500 sm:px-8">
          © {new Date().getFullYear()} YBD INFINITY GLOBAL (202603212324 / JM1048394-W). {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};
